import ToyStyle from "./ToyStyle";

const { regClass, property } = Laya;

@regClass('a8-_Iaa8T2ix_e6Edl0ZTg')
export default class ToyProto {

    shape_id:number;
    prefab:Laya.Prefab;
    style:ToyStyle;
    hasEdge:boolean = false;


    constructor(shape_id:number, prefab: Laya.Prefab, style:ToyStyle, hasEdge:boolean = false) {
        this.shape_id = shape_id;
        this.prefab = prefab;
        this.style = style;
        this.hasEdge = hasEdge;
    }
}